import React from 'react';
import { 
  Percent, Tag, PhoneCall, CheckCircle2, Clock, 
  Sparkles, ShieldCheck, Flame
} from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './DiscountsSection.css';

const discountOffers = [
  {
    id: 1,
    badge: "الأكثر طلباً",
    discount: "50%",
    title: "خصم 50% على ونش إنقاذ القاهرة والجيزة",
    subTitle: "أرخص ونش إنقاذ سيارات داخل أحياء العاصمة الكبرى",
    areas: "المعادي، مدينة نصر، التجمع الخامس، مصر الجديدة، الدقي، المهندسين، 6 أكتوبر، الشيخ زايد، الهرم، فيصل، المقطم، الشروق، مدينتي، الرحاب",
    priceBefore: "500 ج.م",
    priceAfter: "250 ج.م",
    features: [
      "وصول فوري خلال 10 إلى 15 دقيقة",
      "سطحة هيدروليكية مجهزة بأحزمة أمان كاملة",
      "لا توجد أي رسوم خفية أو إكراميات إجبارية",
      "تغطية على مدار 24 ساعة بدون زيادة ليلية"
    ],
    popularKeywords: "ونش انقاذ القاهرة · ارخص ونش انقاذ سيارات · ونش انقاذ الجيزة · ونش انقاذ 24 ساعة",
    isFeatured: true
  },
  {
    id: 2,
    badge: "طرق سريعة",
    discount: "35%",
    title: "خصم 35% على المحاور الحرة والطرق السريعة",
    subTitle: "أسرع ونش إنقاذ على الطرق الدائرية والصحراوية",
    areas: "الطريق الدائري، طريق السويس، طريق مصر الإسكندرية الصحراوي، محور 26 يوليو، طريق العين السخنة، طريق الإسماعيلية، محور المشير، الأوتوستراد",
    priceBefore: "700 ج.م",
    priceAfter: "450 ج.م",
    features: [
      "تمركز دائم عند بوابات الرسوم والنزلات الحيوية",
      "أوناش إنقاذ حوادث وسحب سيارات مقلوبة وعالقة",
      "تأمين موقع العطل بمثلثات تحذيرية وإضاءة ليلية",
      "إمكانية النقل لأي مركز صيانة أو توكيل معتمد"
    ],
    popularKeywords: "ونش انقاذ الدائري · ونش طريق السويس · ونش طريق اسكندرية الصحراوي · اسرع ونش انقاذ",
    isFeatured: false
  },
  {
    id: 3,
    badge: "بين المحافظات",
    discount: "25%",
    title: "خصم 25% لنقل السيارات بين المحافظات والموانئ",
    subTitle: "رحلات السحب الطويلة والنقل الآمن للسيارات الجديدة والفارهة",
    areas: "القاهرة ↔ الإسكندرية والساحل الشمالي، القاهرة ↔ العين السخنة والغردقة، محافظات الدلتا والصعيد وموانئ السويس والإسكندرية",
    priceBefore: "3,500 ج.م",
    priceAfter: "2,600 ج.م",
    features: [
      "سطحات هيدروليكية كاملة (Floor-bed) بزاوية صفرية",
      "تتبع مباشر لحركة السيارة طوال الرحلة عبر GPS",
      "تأمين شامل 100% على هيكل السيارة أثناء النقل",
      "سائقون محترفون ومرخصون لنقل السيارات الحديثة والـ SUV"
    ],
    popularKeywords: "نقل سيارات بين المحافظات · ونش انقاذ الاسكندرية · ونش الساحل الشمالي · ريكفري سيارات",
    isFeatured: false
  },
  {
    id: 4,
    badge: "مساعدة طريق",
    discount: "40%",
    title: "خصم 40% على خدمات المساعدة على الطريق الفورية",
    subTitle: "إسعاف طوارئ سريع بدون الحاجة لرفع أو جر السيارة",
    areas: "جميع مناطق القاهرة والجيزة والطرق المجاورة (خدمة في مكانك)",
    priceBefore: "300 ج.م",
    priceAfter: "180 ج.م",
    features: [
      "شحن وتوصيل وصلة بطارية (Jump Start) بأجهزة حديثة",
      "تغيير وتركيب الإطار الاحتياطي وضبط ضغط الهواء",
      "تزويد وقود طوارئ بنزين / سولار نقي في الموقع",
      "فتح أبواب السيارات المغلقة بأدوات هوائية بدون خدوش"
    ],
    popularKeywords: "شحن بطارية سيارة · تغيير كاوتش طوارئ · بنزين طوارئ · مساعدة على الطريق 24 ساعة",
    isFeatured: false
  }
];

const DiscountsSection = ({ phoneNumber = "01044844492" }) => {
  const cleanPhone = String(phoneNumber || "01044844492").replace(/^0+/, "");
  const displayPhone = phoneNumber.startsWith("0") ? phoneNumber : `0${phoneNumber}`;
  const telHref = `tel:+20${cleanPhone}`;
  const waBase = `https://wa.me/20${cleanPhone}`;

  return (
    <section className="discounts-section" id="discounts" aria-label="عروض وخصومات ونش إنقاذ السيارات">
      <div className="discounts-container">
        
        {/* Header */}
        <div className="discounts-header">
          <div className="discounts-badge">
            <Flame size={18} color="#ef4444" /> عروض وخصومات حصرية 2026
          </div>
          <h2 className="discounts-main-title">
            باقات وعروض أسعار ونش إنقاذ محمد بحر | وفر حتى 50%
          </h2>
          <p className="discounts-lead">
            احصل على <strong>أرخص سعر ونش إنقاذ سيارات في مصر</strong> مع ضمان أعلى معايير الجودة والأمان. اختر منطقتك واستفد من الخصم الفوري عند الاتصال المباشر أو الحجز عبر واتساب.
          </p>
          <div className="promo-timer-pill">
            <Clock size={16} /> <span>العروض سارية اليوم لجميع اتصالات الطوارئ والحجوزات المسبقة</span>
          </div>
        </div>

        {/* Offers Grid */}
        <div className="discounts-grid">
          {discountOffers.map((offer) => (
            <div 
              key={offer.id} 
              className={`discount-card ${offer.isFeatured ? 'featured-card' : ''}`}
            >
              {offer.isFeatured && (
                <div className="featured-ribbon">
                  <Sparkles size={14} /> العرض الأقوى
                </div>
              )}

              <div className="card-top-row">
                <span className="offer-tag"><Tag size={14} /> {offer.badge}</span>
                <div className="discount-circle">
                  <span className="percent-num">خصم {offer.discount}</span>
                </div>
              </div>

              <h3 className="offer-title">{offer.title}</h3>
              <p className="offer-subtitle">{offer.subTitle}</p>

              <div className="offer-areas-box">
                <span className="areas-label">نطاق التغطية والمناطق:</span>
                <p className="areas-text">{offer.areas}</p>
              </div>

              <div className="offer-price-box">
                <div className="price-wrapper">
                  <span className="price-label">الأسعار تبدأ من:</span>
                  <div className="prices">
                    <span className="price-after">{offer.priceAfter}</span>
                    <span className="price-before">{offer.priceBefore}</span>
                  </div>
                </div>
                <span className="discount-save-badge">توفير {offer.discount} فوري</span>
              </div>

              <ul className="offer-features">
                {offer.features.map((feat, idx) => (
                  <li key={idx}>
                    <CheckCircle2 size={16} color="#10b981" />
                    <span>{feat}</span>
                  </li>
                ))}
              </ul>

              <div className="offer-keywords">
                <span className="kw-label">الكلمات الأكثر بحثاً:</span>
                <p className="kw-text">{offer.popularKeywords}</p>
              </div>

              <div className="offer-actions">
                <a href={telHref} className="offer-call-btn">
                  <PhoneCall size={18} /> اطلب الخصم الآن: {displayPhone}
                </a>
                <a 
                  href={`${waBase}?text=${encodeURIComponent(`مرحباً، أرغب في الاستفادة من ${offer.title}`)}`}
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="offer-wa-btn"
                  aria-label="تواصل واتساب للاستفادة من الخصم"
                >
                  <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Trust Banner */}
        <div className="discounts-trust-banner">
          <div className="trust-item">
            <ShieldCheck size={28} color="#0077ff" />
            <div>
              <h4>ضمان تثبيت السعر</h4>
              <p>السعر المتفق عليه في المكالمة هو السعر النهائي بدون أي زيادة عند الوصول.</p>
            </div>
          </div>
          <div className="trust-item">
            <Percent size={28} color="#10b981" />
            <div>
              <h4>خصومات إضافية للمسافات الطويلة</h4>
              <p>خصم خاص للرحلات بين المحافظات ولأصحاب أساطيل الشركات والمعارض.</p>
            </div>
          </div>
          <div className="trust-item">
            <Clock size={28} color="#f59e0b" />
            <div>
              <h4>خدمة طوارئ 24/7</h4>
              <p>جاهزون لإنقاذ وسحب سيارتك في أي وقت ليلاً أو نهاراً بجميع المحافظات.</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default DiscountsSection;
